import { FileTypes, getStorageObjectPath } from '@usacsmideo/types';

/**
 * Storage path for a patient's ABN signature (CU-17tm466h63z, Phase 5): the
 * canonical `getStorageObjectPath(patientId, abnSig)` →
 * `user/{patientId}/signatures/ABN_INFO_Signature`, the same object the app
 * writes and the printer reads.
 *
 * ⚠️ Takes the ROUTE patientId deliberately. `getFileUploadPath` uses
 * `auth.currentUser.uid`, which in family / healthcare-agent flows is the
 * person signing ON BEHALF of the patient — it would put the signature in the
 * agent's folder.
 */
export const abnSignaturePath = (patientId: string): string => {
  if (!patientId) {
    throw new Error('abnSignaturePath requires the patientId');
  }
  return getStorageObjectPath(patientId, FileTypes.abnSig);
};
